import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M2.862 2.862a.67.67 0 0 1 .471-.195H6a.667.667 0 0 0 0-1.334H3.333a2 2 0 0 0-2 2v9.334a2 2 0 0 0 2 2H6a.667.667 0 0 0 0-1.334H3.333a.667.667 0 0 1-.666-.666V3.333c0-.177.07-.346.195-.471"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M10.195 4.195c.26-.26.683-.26.943 0l3.333 3.334c.26.26.26.682 0 .942l-3.333 3.334a.667.667 0 1 1-.943-.943l2.196-2.195H6a.667.667 0 1 1 0-1.334h6.39l-2.195-2.195a.667.667 0 0 1 0-.943"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })